import { canUseAdminDevTools } from './adminUsers.js';
import {
  initDevDarkMode,
  clearDevDarkMode,
  DEV_DARK_STORAGE_KEY,
  isStoredDevDarkModeEnabled,
} from './devDarkMode.js';
import { initDevSidebarCollapsed } from '../context/DevSidebarContext.js';

export function hasStoredAdminDevPreferences() {
  return localStorage.getItem(DEV_DARK_STORAGE_KEY) !== null;
}

export function shouldShowAdminDarkLoading(email) {
  if (!isStoredDevDarkModeEnabled()) return false;
  if (email) return canUseAdminDevTools(email);

  return hasStoredAdminDevPreferences();
}

export function restoreAdminDevToolsFromStorage() {
  initDevSidebarCollapsed();

  if (!hasStoredAdminDevPreferences()) return;

  document.documentElement.classList.toggle('dev-dark', isStoredDevDarkModeEnabled());
}

export function syncAdminDevTools(email, { authPending = false } = {}) {
  initDevSidebarCollapsed();

  if (canUseAdminDevTools(email)) {
    initDevDarkMode(email);
    return;
  }

  if (authPending && !email) {
    if (hasStoredAdminDevPreferences()) {
      document.documentElement.classList.toggle('dev-dark', isStoredDevDarkModeEnabled());
    }
    return;
  }

  clearAdminDevTools();
}

export function clearAdminDevTools() {
  clearDevDarkMode();
}
